<template>
    <PageSection fixed>
        <PageHeader :title="title"></PageHeader>
        <Card>
            <ApprovalsTable :empty-state="emptyState" is-approvals-page />
        </Card>
    </PageSection>
</template>

<script setup lang="ts">
import { definePage } from "vue-router/auto";
import ApprovalsTable, {
	type EmptyStateConfig,
} from "../../components/Requests/RequestsTable.vue";
import { useInstitution as useInstitutionConfig } from "../../composables/useInstitution";

const { institutionConfig } = useInstitutionConfig();

const emptyState: EmptyStateConfig = {
	text: {
		noApprovals: "There are no approvals to action.",
		noMatches: "There are no approvals matching your search term or filters.",
	},
	nav: {
		text: "Review approval history",
		to: "/requests/history",
	},
};

const title = computed(() => {
	return institutionConfig.value.approval_config === "adoption_approvals"
		? "Approvals"
		: "Requests";
});

definePage({
	meta: {
		requiresAuth: true,
		customPermission: "hasRequestsPageAccess",
	},
	alias: ["/approvals"],
});
</script>
